<template>
  <div class="list-box">
    <div class="check-box">
      <van-checkbox
        v-model="page.less30m"
        shape="square"
        icon-size="1.2em"
        @change="getSubscribeList"
        >30分钟内问诊</van-checkbox
      >
      <van-checkbox
        v-model="page.askStatus"
        shape="square"
        icon-size="1.2em"
        @change="getSubscribeList"
        >待问诊</van-checkbox
      >
    </div>
    <template v-if="list.length">
      <div
        class="item-box"
        v-for="(item, index) in list"
        :key="index"
        v-watermark
      >
        <div class="top-info">
          <div>{{ item.userMemberName }}</div>
          <div class="age-box">
            {{
              `${{ 1: "男", 0: "女" }[item.userMemberSex] || "未知"} | ${
                item.userMemberAge + "岁"
              }`
            }}
          </div>
          <div
            class="type-box"
            :class="{
              picture: [AskMethodType.IMAGE, AskMethodType.PHONE].includes(item.askType),
              video: item.askType === AskMethodType.VIDEO
            }"
          >
            {{ askMethodTypes.findValue({value: item.askType}) }}
          </div>
          <div
            class="status"
            :style="{
              color: askReservationStatusFind(item.apptAskStatus).color,
            }"
          >
            {{ askReservationStatusFind(item.apptAskStatus).label }}
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div class="item-info">
            <div class="item-lable">联系电话：</div>
            <div class="item-value">{{ item.userMemberMobile || "-" }}</div>
          </div>
          <div class="item-info">
            <div class="item-lable">来源：</div>
            <div class="item-value">
              {{ getDictOptionsLabel(originList, item.origin) }}
            </div>
          </div>
        </div>
        <div class="item-info">
          <div class="item-lable">预约时间：</div>
          <div class="item-value">{{ getSubscribeTime(item) }}</div>
        </div>
        <div class="item-info">
          <div class="item-lable">预约医生：</div>
          <div class="item-value">{{ item.doctorName || "-" }}</div>
        </div>
        <div class="button-box">
          <template v-if="item.askStatus === 0">
            <div @click="onCancel(item)" class="cancel-box">
              <div class="mini-icon"></div>
              <span>取消预约</span>
            </div>
            <div @click="onEdit(item)" class="edit-box">
              <div class="mini-icon"></div>
              <span>修改预约</span>
            </div>
          </template>
          <template v-if="item.apptAskStatus === 3">
            <div class="cancel-box" @click="onCancel(item)">
              <div class="mini-icon"></div>
              <span>取消预约</span>
            </div>
            <div
              class="write-box"
              @click="$router.push(`/reservation/pay?askNo=${item.askNo}`)"
            >
              立即支付
            </div>
          </template>
          <template v-else>
            <div
              @click="onWrite(item)"
              class="write-box"
              v-if="item.askStatus === 0"
            >
              预填问诊信息
            </div>
            <div
              @click="onNextSubscribe(item)"
              class="write-box"
              v-if="[7, 8].includes(item.askStatus)"
            >
              重新预约
            </div>
          </template>
        </div>
      </div>
      <div
        class="pagination"
        v-if="page.total > page.pageSize"
        style="padding: 20px 0"
      >
        <van-pagination
          v-model="page.pageNo"
          :total-items="page.total"
          :items-per-page="page.pageSize"
          @change="pageChange"
        >
          <template #prev-text>
            <van-icon name="arrow-left" />
          </template>
          <template #next-text>
            <van-icon name="arrow" />
          </template>
          <template #page="{ text }">{{ text }}</template>
        </van-pagination>
      </div>
    </template>
    <van-empty description="暂无数据" v-else />
  </div>
</template>

<script>
import { getReservationList } from "@/api/reservation";
import { cancelSubscribe } from "@/api/subscribe";
import { timeFormat } from "@/utils/baseFormat";
import { getDictOptionsLabel } from "@/utils/function";
import { originList, askReservationStatusFind } from "./dict";
import { askMethodTypes } from '@/hooks/useAsk'
import { AskMethodType } from '@/hooks/useAsk/type'
export default {
  name: "ReservationList",
  components: {},
  data() {
    return {
      list: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        keyword: "",
        isAppt: 1,
        total: 0,
        askStatus: false,
        less30m: false
      },
      askMethodTypes,
      AskMethodType,
      originList: originList,
    };
  },
  methods: {
    getDictOptionsLabel,
    askReservationStatusFind,
    setPageParams(keyword) {
      this.page.pageNo = 1;
      this.page.pageSize = 10;
      this.page.keyword = keyword;
      this.getSubscribeList();
    },
    async getSubscribeList() {
      try {
        const {
          data: { list, total },
        } = await getReservationList({
          ...this.page,
          assistantNo: this.$store.state.assistantNo,
          askStatus: this.page.askStatus ? 0 : null,
          less30m: this.page.less30m ? 1 : 0
        });
        this.list = list;
        this.page.total = total;
      } catch (error) {
        this.list = [];
        console.log(error);
      }
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.getSubscribeList();
    },
    getSubscribeTime(item) {
      if (!item) return "-";
      // return `${timeFormat(item.apptStartTime)} ${timeFormat(
      //   item.apptStartTime,
      //   "hh:MM"
      // )}~${timeFormat(item.apptEndTime, "hh:MM")}`;

      return item.apptStartTime +'~'+ item.apptEndTime
    },
    onEdit(item) {
      this.$router.push({
        name: "ReservationEdit",
        query: {
          userMemberId: item.userMemberId,
          doctorNo: item.doctorNo,
          askNo: item.askNo,
        },
      });
    },
    onCancel(item) {
      this.$dialog
        .alert({
          title: "提示",
          message: "确定取消预约吗？",
          showCancelButton: true,
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          cancelButtonColor: "#666666",
          confirmButtonColor: "#0082ef",
        })
        .then(async () => {
          console.log("确定");
          try {
            await cancelSubscribe({ askNo: item.askNo });
            this.$toast("取消成功");
            this.getSubscribeList();
          } catch (error) {
            this.$toast("取消失败");
          }
        })
        .catch(() => {
          console.log("取消");
        });
    },
    onWrite({ userNo, userMemberId, askNo }) {
      this.$router.push({
        name: "PreAsk",
        query: {
          userNo,
          userMemberId,
          askNo,
        },
      });
    },
    onNextSubscribe(item) {
      this.$router.push({
        name: "Reservation",
        query: {
          userMemberId: item.userMemberId,
          doctorNo: item.doctorNo,
        },
      });
    },
  },
  computed: {},
  watch: {},
  created() {
    this.getSubscribeList();
  },
  activated() {
    this.getSubscribeList();
  },
};
</script>
<style lang="scss" scoped>
.list-box {
  .check-box {
    padding: 15px;
    background: #fff;
    font-size: 15px;
    display: flex;
    align-items: center;
    .van-checkbox {
      :deep(.van-checkbox__label) {
        line-height: inherit;
      }
      &:not(:first-child) {
        margin-left: 30px;
      }
    }
  }

  .item-box {
    background: #fff;
    border-radius: 0 0 4px 4px;
    padding: 15px;

    & + .item-box {
      margin-top: 15px;
    }

    .top-info {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      display: flex;
      align-items: center;

      .type-box {
        font-size: 12px;
        width: 80px;
        height: 22px;
        font-weight: normal;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;

        &.video {
          background: url("@/assets/images/subscribe/video.png") no-repeat
            center/cover;
        }

        &.picture {
          background: url("@/assets/images/subscribe/picture.png") no-repeat
            center/cover;
        }
      }

      .age-box {
        padding: 0 10px;
      }

      .status {
        margin-left: auto;
        color: #ffa200;
      }
    }

    .item-info {
      flex: 1;
      display: flex;
      align-items: center;
      margin-top: 12px;
      font-size: 14px;

      .item-lable {
        color: #666666;
      }

      .item-value {
        color: #333333;
      }
    }

    .button-box {
      display: flex;
      align-items: center;
      margin-top: 10px;

      .cancel-box,
      .edit-box {
        display: flex;
        color: #f45430;
        font-size: 13px;
        cursor: pointer;

        &:active {
          transform: scale(0.99);
          opacity: 0.99;
        }

        .mini-icon {
          width: 18px;
          height: 18px;
          background: url("@/assets/images/subscribe/cancel-icon.png") no-repeat
            center/cover;
          margin-right: 3px;
        }
      }

      .edit-box {
        margin-left: 15px;
        color: #0082ef;

        .mini-icon {
          background: url("@/assets/images/subscribe/edit-icon.png") no-repeat
            center/cover;
        }
      }

      .write-box {
        color: white;
        padding: 7px 20px;
        background: #0082ef;
        border-radius: 22px;
        margin-left: auto;
        cursor: pointer;
      }
    }
  }
}
</style>
